var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhotoGuidIcon1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9768_229524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F4F6F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9768_229524)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 11.1631,
    y: 11.1629,
    width: 237.209,
    height: 298.605,
    fill: "#FFC7CB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    x: 25.1167,
    y: 25.115,
    width: 34.8837,
    height: 45.3488,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line",
    d: "M10.5875 30.1209C10.2697 30.4387 10.2697 30.9541 10.5875 31.272L15.7675 36.4519C16.0854 36.7698 16.6007 36.7698 16.9186 36.4519C17.2365 36.1341 17.2365 35.6187 16.9186 35.3008L12.3142 30.6964L16.9186 26.092C17.2365 25.7741 17.2365 25.2588 16.9186 24.9409C16.6007 24.623 16.0854 24.623 15.7675 24.9409L10.5875 30.1209ZM25.6921 31.272C26.01 30.9541 26.01 30.4387 25.6921 30.1209L20.5122 24.9409C20.1943 24.623 19.6789 24.623 19.3611 24.9409C19.0432 25.2588 19.0432 25.7741 19.3611 26.092L23.9655 30.6964L19.3611 35.3008C19.0432 35.6187 19.0432 36.1341 19.3611 36.4519C19.6789 36.7698 20.1943 36.7698 20.5122 36.4519L25.6921 31.272ZM11.1631 31.5104L25.1166 31.5104L25.1166 29.8825L11.1631 29.8825L11.1631 31.5104Z",
    fill: "#FF0008"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    d: "M29.8783 10.5874C29.5604 10.2695 29.0451 10.2695 28.7272 10.5874L23.5472 15.7674C23.2293 16.0852 23.2293 16.6006 23.5472 16.9185C23.8651 17.2363 24.3804 17.2363 24.6983 16.9185L29.3027 12.3141L33.9072 16.9185C34.225 17.2363 34.7404 17.2363 35.0583 16.9185C35.3761 16.6006 35.3761 16.0852 35.0583 15.7674L29.8783 10.5874ZM28.7272 25.692C29.0451 26.0099 29.5604 26.0099 29.8783 25.692L35.0583 20.512C35.3761 20.1942 35.3761 19.6788 35.0583 19.3609C34.7404 19.043 34.225 19.043 33.9072 19.3609L29.3027 23.9653L24.6983 19.3609C24.3804 19.043 23.8651 19.043 23.5472 19.3609C23.2293 19.6788 23.2293 20.1941 23.5472 20.512L28.7272 25.692ZM28.4888 11.1629L28.4888 25.1164L30.1167 25.1164L30.1167 11.1629L28.4888 11.1629Z",
    fill: "#FF0008"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    x1: 37.0928,
    y1: 35.4639,
    x2: 59.1858,
    y2: 35.4639,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    x1: 37.0928,
    y1: 41.0454,
    x2: 59.1858,
    y2: 41.0454,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    x1: 37.0928,
    y1: 46.6269,
    x2: 59.1858,
    y2: 46.6269,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    x1: 37.0928,
    y1: 52.2084,
    x2: 59.1858,
    y2: 52.2084,
    stroke: "#434343",
    strokeWidth: 1.62791,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    cx: 30,
    cy: 30,
    r: 29.186,
    stroke: "#F5F5F5",
    strokeWidth: 1.62791
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGuidIcon1);
export default __webpack_public_path__ + "static/media/photo-guid-icon-1.eaa74b09e0c7783e6388bc83e99f34d9.svg";
export { ForwardRef as ReactComponent };